const setMetaTag = (
    attribut: string,
    key: string,
    content: string,
) => {
    if(content) {
        let element = document.querySelector(`meta[${attribut}="${key}]`);
        if(!element) {
            element = document.createElement('meta');
            element.setAttribute(attribut, key);
            document.head.appendChild(element);
        }
        element.setAttribute('content', content);
    }
}

const setLinkTag = (
    attribut: string,
    key: string,
    content: string,
) => {
    if(content) {
        let element = document.querySelector(`link[${attribut}="${key}]]`);
        if(!element) {
            element = document.createElement('link');
            element.setAttribute(attribut, key);
            document.head.appendChild(element);
        }
        element.setAttribute('href', content);
    }
}

const setTitle = (title: string) => {
    document.title = title;
}

export const setMetaTags = (
        title: string,
        description: string,
        ogTitle: string,
        ogDescription: string,
        ogImage: string,
        ogUrl: string,
        ogType: string,
        ogLocale: string,
        ogSiteName: string,
        favicon: string
    ) => {
    setTitle(title);

    setLinkTag('rel','icon',favicon);
    setMetaTag('name','description', description);
    setMetaTag('property','og:title', ogTitle || title);
    setMetaTag('property','og:description', ogDescription);
    setMetaTag('property','og:image', ogImage);
    setMetaTag('property','og:url', ogUrl || window.location.href);
    setMetaTag('property','og:type', ogType);
    setMetaTag('property','og:locale', ogLocale);
    setMetaTag('property','og:site_name', ogSiteName);
}



